import { useEffect, useRef } from 'react';
import {
  BaseToolInvocation,
  CONTACT_FORM_TOOL_NAME,
  ConversationMessageDto,
  ToolInvocationSchema,
} from '@endion/types';
import { useChatContext } from '../hooks/use-chat-context';
import { ContactForm } from './component-message/contact-form';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const COMPONENTS: Record<string, React.FC<any>> = {
  [CONTACT_FORM_TOOL_NAME]: ContactForm,
};

export function DynamicMessageComponent({
  toolInvocation,
  message,
}: {
  toolInvocation: BaseToolInvocation | undefined;
  message: ConversationMessageDto;
}) {
  const { isOpen } = useChatContext();
  const componentContainerRef = useRef<HTMLElement | null>(null);

  // Scroll into view the component upon mounting
  useEffect(() => {
    // Ignore the scrolling logic if the chat is not visible or the component is part of the received conversation history
    // We only want to scroll into view incoming chat components
    if (!isOpen || !componentContainerRef.current) return;

    componentContainerRef.current.scrollIntoView({ behavior: 'smooth' });
  }, []);

  if (!toolInvocation) return null;
  const Component = COMPONENTS[toolInvocation.name];
  // some tools may not have a corresponding component
  // in that case, we just return null
  if (!Component) return null;
  const toolInvocationWithParsedResult = {
    ...toolInvocation,
    result: toolInvocation.result ? JSON.parse(toolInvocation.result) : undefined,
  };

  const toolInvocationFull = ToolInvocationSchema.parse(toolInvocationWithParsedResult);

  return <Component toolInvocation={toolInvocationFull} message={message} ref={componentContainerRef} />;
}
